module.exports = __webpack_public_path__ + "media/images/hamb-black-3677f4791299ecdd9319b1e8d2bdaae3.svg";